import Select from "../../../form/select/Select";

const SavingsInterest = ({
  rate,
  values,
  errors,
  edit,
  touched,
  handleBlur,
  handleChange,
  setFieldValue,
}) => {
  // const calculationType = [
  //   { label: "Simple Interest", value: "simple interest" },
  //   { label: "Compound Interest", value: "compound interest" },
  // ];
  // const postingPeriod = [
  //   // {label:"Daily", value:"daily"},
  //   { label: "Monthly", value: "monthly" },
  //   { label: "Annually", value: "annually" },
  //   // {label:"Bi-Annually", values: "bi-annually"}
  // ];
  // const compoundingPeriod = [
  //   // {label:"Daily", value:"daily"},
  //   { label: "Monthly", value: "monthly" },
  //   { label: "Annually", value: "annually" },
  //   // {label:"Bi-Annually", value: "bi-annually"}
  // ];
  return (
    <div>
      <div className='position-relative'>
        <h5 className='text-primary-1 mt-2'>RATE</h5>
        <div className='row'>
          <div className='col-md-3 mb-2'>
            <label
              htmlFor='policy_name'
              className={`form-label ${edit ? "" : "fw-bolder"}`}
            >
              Default Rate{" "}
              {edit ? <span className='text-danger'>*</span> : null}
            </label>
            {!edit ? <p>{rate?.default_rate}</p> : null}
            {edit ? (
              <>
                <input
                  type='text'
                  className={`form-control ${
                    (errors?.default_interest_rate || errors?.default_rate) &&
                    touched?.default_interest_rate &&
                    "is-invalid"
                  }`}
                  name='default_interest_rate'
                  id='default_interest_rate'
                  defaultValue={values?.default_interest_rate}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder='0.00'
                />
                {(errors?.default_interest_rate || errors?.default_rate) &&
                  touched?.default_interest_rate && (
                    <span className='text-danger'>
                      {errors?.default_interest_rate || errors?.default_rate}
                    </span>
                  )}
              </>
            ) : null}
          </div>
          <div className='col-md-3 mb-2'>
            <label
              htmlFor='policy_name'
              className={`form-label ${edit ? "" : "fw-bolder"}`}
            >
              Minimum Rate
              {edit ? <span className='text-danger'>*</span> : null}
            </label>
            {!edit ? <p>{rate?.minimum_rate}</p> : null}
            {edit ? (
              <>
                <input
                  type='text'
                  className={`form-control ${
                    (errors?.minimum_interest_rate || errors?.min_rate) &&
                    touched?.minimum_interest_rate &&
                    "is-invalid"
                  }`}
                  name='minimum_interest_rate'
                  id='minimum_interest_rate'
                  value={values?.minimum_interest_rate}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder='0.00'
                />
                {(errors?.minimum_interest_rate || errors?.min_rate) &&
                  touched?.minimum_interest_rate && (
                    <span className='text-danger'>
                      {errors?.minimum_interest_rate || errors?.min_rate}
                    </span>
                  )}
              </>
            ) : null}
          </div>
          <div className='col-md-3 mb-2'>
            <label
              htmlFor='policy_name'
              className={`form-label ${edit ? "" : "fw-bolder"}`}
            >
              Maximum Rate{" "}
              {edit ? <span className='text-danger'>*</span> : null}
            </label>
            {!edit ? <p>{rate?.maximum_rate}</p> : null}
            {edit ? (
              <>
                <input
                  type='text'
                  className={`form-control ${
                    errors?.maximum_interest_rate &&
                    touched?.maximum_interest_rate &&
                    "is-invalid"
                  }`}
                  name='maximum_interest_rate'
                  id='maximum_interest_rate'
                  value={values?.maximum_interest_rate}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder='0.00'
                />
                {errors?.maximum_interest_rate &&
                  touched?.maximum_interest_rate && (
                    <span className='text-danger'>
                      {errors?.maximum_interest_rate}
                    </span>
                  )}
              </>
            ) : null}
          </div>
        </div>
        {/* <div className='row'>
          <div className='col-md-3 mb-2'>
            <label
              htmlFor='policy_name'
              className={`form-label ${edit ? "" : "fw-bolder"}`}
            >
              Interest Calculation Type{" "}
              {edit ? <span className='text-danger'>*</span> : null}
            </label>
            {!edit ? <p>{rate?.interest_cal_type}</p> : null}
            {edit ? (
              <>
                <Select
                  isError={
                    errors?.interest_cal_type &&
                    touched?.interest_cal_type &&
                    !values?.interest_cal_type
                  }
                  name='interest_cal_type'
                  data={calculationType.map((item, i) => ({
                    label: item.label,
                    value: item.value,
                  }))}
                  value={values.interest_cal_type}
                  onChange={(selectedOption) =>
                    setFieldValue("interest_cal_type", selectedOption?.value)
                  }
                  onBlur={() =>
                    handleBlur({ target: { name: "interest_cal_type" } })
                  }
                />
                {errors?.interest_cal_type && touched?.interest_cal_type && (
                  <span className='text-danger'>
                    {errors?.interest_cal_type}
                  </span>
                )}
              </>
            ) : null}
          </div>
          <div className='col-md-3 mb-2'>
            <label
              htmlFor='policy_name'
              className={`form-label ${edit ? "" : "fw-bolder"}`}
            >
              Interest Posting Period
              {edit ? <span className='text-danger'>*</span> : null}
            </label>
            {!edit ? <p>{rate?.interest_posting_period}</p> : null}
            {edit ? (
              <>
                <Select
                  isError={
                    errors?.interest_posting_period &&
                    touched?.interest_posting_period &&
                    !values?.interest_posting_period
                  }
                  name='interest_posting_period'
                  data={postingPeriod.map((item, i) => ({
                    label: item.label,
                    value: item.value,
                  }))}
                  value={values.interest_posting_period}
                  onChange={(selectedOption) =>
                    setFieldValue(
                      "interest_posting_period",
                      selectedOption?.value
                    )
                  }
                  onBlur={() =>
                    handleBlur({ target: { name: "interest_posting_period" } })
                  }
                />
                {errors?.interest_posting_period &&
                  touched?.interest_posting_period && (
                    <span className='text-danger'>
                      {errors?.interest_posting_period}
                    </span>
                  )}
              </>
            ) : null}
          </div>
          <div className='col-md-3 mb-2'>
            <label
              htmlFor='policy_name'
              className={`form-label ${edit ? "" : "fw-bolder"}`}
            >
              Interest Compounding Period{" "}
              {edit ? <span className='text-danger'>*</span> : null}
            </label>
            {!edit ? <p>{rate?.interest_compound_period}</p> : null}
            {edit ? (
              <>
                <Select
                  isError={
                    errors?.interest_compound_period &&
                    touched?.interest_compound_period &&
                    !values?.interest_compound_period
                  }
                  name='interest_compound_period'
                  data={compoundingPeriod.map((item, i) => ({
                    label: item.label,
                    value: item.value,
                  }))}
                  value={values.interest_compound_period}
                  onChange={(selectedOption) =>
                    setFieldValue(
                      "interest_compound_period",
                      selectedOption?.value
                    )
                  }
                  onBlur={() =>
                    handleBlur({ target: { name: "interest_compound_period" } })
                  }
                />
                {errors?.interest_compound_period &&
                  touched?.interest_compound_period && (
                    <span className='text-danger'>
                      {errors?.interest_compound_period}
                    </span>
                  )}
              </>
            ) : null}
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default SavingsInterest;
